import * as z from 'zod';

export const InviteFormSchema = z.object({
  to: z.string(),
  title: z.string().min(1, { message: 'Title is required' }),
  custom_message: z.string().min(1, { message: 'Message is required' }),
});

export type InviteFormSchemaPayload = z.infer<typeof InviteFormSchema>;
